import * as React from "react";

type IconProps = {
	color?: string;
	size?: number;
};

export const MenuListSearchIcon = ({ color = "#A4A7AE", size = 20 }: IconProps) => (
	<svg width={size} height={size} viewBox="0 0 20 20" fill="none" aria-hidden="true">
		<path
			d="M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z"
			stroke={color}
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const SORT_ICON_INACTIVE = "#64748B";
const SORT_ICON_ACTIVE = "#FB2F2F";

/** arrow-up — ascending sort */
export const MenuListSortAscIcon = ({
	color = SORT_ICON_INACTIVE,
	size = 16,
}: IconProps) => (
	<svg width={size} height={size} viewBox="0 0 16 16" fill="none" aria-hidden="true">
		<path
			d="M8 12.6667V3.33333M12.6667 8L8 3.33333L3.33333 8"
			stroke={color}
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

/** arrow-narrow-down — descending sort */
export const MenuListSortDescIcon = ({
	color = SORT_ICON_INACTIVE,
	size = 16,
}: IconProps) => (
	<svg width={size} height={size} viewBox="0 0 16 16" fill="none" aria-hidden="true">
		<path
			d="M8 2.66667V13.3333M4 9.33333L8 13.3333L12 9.33333"
			stroke={color}
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const menuListSortIconColor = (active: boolean) =>
	active ? SORT_ICON_ACTIVE : SORT_ICON_INACTIVE;
